<template>
	<div>
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="mainTitle text-center my-3">
            <h2 class="mb-3">{{$t('autoscan_AutochartistScanner')}}</h2>
        </div>
        <div class=" traderBox whiteBG radius mb-3 px-md-4 py-md-4 py-xs-3 border">
        	<div class="row align-items-center">
				<div class="col-12 col-md-6 text-center">
					<div>
						<img src="../../../../static/fxView/images/auto-chartist-page.svg" alt="Email Support" class="mtImg-svg">
					</div> 
				</div>
			    <div class="col-12 col-md-6">
					<!-- <p>{{$t('AutochartistfinestSupplement')}}</p> -->
           			<p>{{$t('autoscan_IBintegrateAdvancedTool')}} <a :href="$env_var.websiteLink+'/autoChartist'"  target="_blank">{{$t('autoScan_knoMore')}} </a></p>
           			
           			<!-- <a href="#" class="btn_xs grd_btn clk" @click.prevent="subscribeFormFunc()">{{$t('autoScan_DownLive')}} </a> -->

           			<a href="#" class="common_btn btn_sm  " @click.prevent="subscribeFormFunc()">{{$t('autoScan_DownLive')}} </a>

           			
           			<!-- <div class="mb-3 d-flex flex-wrap align-item-center justify-content-start" > 
						<a href="#" class="prism_btn darkBG btn_sm mr-md-3">Download AutoChartist Scanner</a>  
						<a href="#" class="prism_btn btn_sm mr-md-3">User Guide</a> 
					</div> --> 
			  	</div>
		     </div>
        </div>
     	<!-- <div class="traderBox mb-3">
	        <div class="row">
	            <div class="col-12 col-md-4">
	            	<div class="subscribeReport border p-4 whiteBG">
	            		<img src="../../../../static/fxView/images/sr_tradingaccount.png" alt="Email Support" class="mtImg">
	                	<h5>Download for Live Account</h5>
	                	<a href="#" class="prism_btn btn_sm" @click.prevent="subscribeFormFunc()">{{$t('clickHere')}}</a>
	            	</div>
	            </div>
	            <div class="col-12 col-md-4">
	            	<div class="subscribeReport border p-4 whiteBG">
	            		<img src="../../../../static/fxView/images/rocket_block.png" alt="Email Support" class="mtImg">
	                    <h5>User & Installation guide</h5>
	                    <a href="https://www.autochartist.com/metatrader-plugin/index-metatrader.html" target="_blank" class="prism_btn btn_sm">{{$t('clickHere')}} </a>
	                </div>
	            </div>
	            <div class="col-12 col-md-4">
	            	<div class="subscribeReport border p-4 whiteBG">
	            		<img src="../../../../static/fxView/images/sr_chart.png" alt="Email Support" class="mtImg">
	                    <h5>AutoChartist Web Platform</h5>
	                    <a href="#" class="prism_btn btn_sm" @click.prevent="$parent.changeTab('AutoChartist-Web')">Launch</a> 
	                </div>
	            </div>
	         </div>
        </div> -->
        <div class="border traderBox mb-3 whiteBG px-md-4 py-md-4 py-xs-3">
        	<div class="d-flex justify-content-between align-items-center">
        		<h5 class="mb-0">{{$t('autoScan_HowInstall')}}   </h5> 
        		<!---href="https://www.autochartist.com/metatrader-plugin/index-metatrader.html"--->
        	  	
        	</div>
	        <div class="row downloadT">
	        	
	        	<div class="col-12 col-md-6">
	                <ul class="listing p-3">
	                    <li>{{$t('autoscan_closeMt4')}}</li>
	                    <li>{{$t('autoscan_DownloadRunAuto')}}</li>
	                    <li>{{$t('autoscan_SelectPortfoliosTrading')}}</li>
	                    <li>{{$t('autoScan_goTool')}}</li>
	                    <li>{{$t('autoscan_RestartMt4Platform')}}</li>
	                </ul>
	         </div> 

	        </div>
	        <div class="userguide w-auto">
	        <a  :href="$env_var.userGuide"  class="btn_xs grd_btn clk d-flex align-items-center"   target="_blank" ><feather class="mr-2" size="17px" type="download"></feather> {{$t('autoScan_usrGuide')}} </a>
	        </div>
        </div>
        <div class=" border step-bottom-alert mb-5 whiteBG text-center justify-content-center">
			<span class="position-relative l-0"><feather type="alert-circle"></feather></span> 
			<p class="ml-2">{{$t('autoscan_autochartistdesc')}} </p>
		</div>
        <div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
			<div class="col-12 col-md-10">
				<small>{{$t('autoscan_DisclaimerAutoChartist')}}</small>
			</div>
		</div>
    </div>
</template>
<script>
	export default {
		name: 'Signal-Centre',
		data() {
			return {
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				SubscribeForm : false,
			}
		},
		methods:{
			subscribeFormFunc(){
                let input_json = {
                    'globalParams' : {
                        
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetAutochartistUrl(input_json)
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/autochartist_scanner.vue